import { render, staticRenderFns } from "./unsatisfactory-receiving-detail.vue?vue&type=template&id=20d70120&scoped=true"
import script from "./unsatisfactory-receiving-detail.vue?vue&type=script&lang=js"
export * from "./unsatisfactory-receiving-detail.vue?vue&type=script&lang=js"
import style0 from "./unsatisfactory-receiving-detail.vue?vue&type=style&index=0&id=20d70120&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d70120",
  null
  
)

export default component.exports